// src/utils/moonPhaseMap.js

const moonPhaseMap = {
    "New Moon": "newMoon",
    "Waxing Crescent": "waxingCrescentMoon",
    "First Quarter": "firstQuarterMoon",
    "Waxing Gibbous": "waxingGibbousMoon",
    "Full Moon": "fullMoon",
    "Waning Gibbous": "waningGibbousMoon",
    "Last Quarter": "lastQuarterMoon",
    "Waning Crescent": "waningCrescentMoon",
  
    default: "fullMoon" // Fallback, falls etwas fehlt
  };
  
  export default moonPhaseMap;
  
  